export class User {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  contact_number: string;
  state: 'active' | 'inactive';
  qlik_enabled: boolean;
  role: 'platform_admin' | 'finance_user';
  cdp_enabled: boolean;

  constructor() {
    this.state = 'inactive';
    this.qlik_enabled = false;
    this.role = 'platform_admin';
    this.cdp_enabled = false;
  }
}

export class PrimaryDetails {
  name: string;
  msa_entity: string;
  msa_date;
  msa_id: string;

  constructor() {
    this.msa_entity = "US";
  }
}

export class PrimaryAdmin {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  contact_number: string;
  cdp_enabled: boolean;

  constructor() {
    this.cdp_enabled = false;
  }
}

export class QlikSettings {
  free_basic_users: number;
  free_advanced_users: number;
  basic_user_fee: number;
  advanced_user_fee: number;

  constructor() {
    this.free_basic_users = 0;
    this.free_advanced_users = 0;
    this.basic_user_fee = 0.00;
    this.advanced_user_fee = 0.00;
  }
}

export class Organization {
  name: string;
  website: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  pincode: string;
  phone_code: string;
  phone_number: string;
  billing_address1: string;
  billing_address2: string;
  billing_country: string;
  billing_state: string;
  billing_city: string;
  billing_pincode: string;
  political_details: PoliticalDetails;

  constructor() {
    this.political_details = new PoliticalDetails();
    this.address2 = "";
    this.billing_address2 = "";
    this.website = "";
  }
}

export class AdspDetails{
  adsp_tag_id;
  merchant_token;
  industry;
  constructor(){
    this.industry = 'automotive';
  }
}
export class TdspDetails {
  run_political_ads: boolean;
  targetingEU: boolean;
  isAdvPayer: boolean;
  click_lb: number;
  imp_lb_win_sec: number;
  click_dedup_sec: number;
  conv_dedup_sec: number;
  category_parent_id: number;
  category_id: number;
  payer_name: string;
  eu_advertiser_name: string;

  constructor() {
    this.run_political_ads = false;
    this.targetingEU = false;
    this.isAdvPayer = true;
    this.click_lb = 14;
    this.imp_lb_win_sec = 7;
    this.click_dedup_sec = 5;
    this.conv_dedup_sec = 60;
  }
}
export class AgnAdvTdspDetails {
  run_political_ads: boolean;
  targetingEU: boolean;
  isAdvPayer: boolean;
  category_parent_id: number;
  category_id: number;
  payer_name: string;
  eu_advertiser_name: string;
  margin_pct: number;
  click_lb: number;
  imp_lb_win_sec: number;
  click_dedup_sec: number;
  conv_dedup_sec: number;

  constructor() {
    this.run_political_ads = false;
    this.targetingEU = false;
    this.isAdvPayer = true;
    this.margin_pct = 0;
    this.click_lb = 14;
    this.imp_lb_win_sec = 7;
    this.click_dedup_sec = 5;
    this.conv_dedup_sec = 60;
  }
}

export class AgnTdspDetails {
  click_lb: number;
  imp_lb_win_sec: number;
  click_dedup_sec: number;
  conv_dedup_sec: number;

  constructor() {
    this.click_lb = 14;
    this.imp_lb_win_sec = 7;
    this.click_dedup_sec = 5;
    this.conv_dedup_sec = 60;
  }
}

export class PoliticalDetails {
  fec_id: number;
  treasurer_name: string;
  payment_method: string;
  payment_method_other: string;
  political_objective: string;
  is_independent_committee: boolean;
  is_registration_form_required: boolean;
  registration_form_url: string;
  government_level: string;
  is_accuracy_acknowledged: boolean;
  constructor() {
    this.payment_method = 'direct_debit';
    this.government_level = 'local_or_state'
    this.is_independent_committee = false;
    this.is_accuracy_acknowledged = false
  }
}

export class bdspCommission {
  commission: number;
  start_date;
}

export class adspCommission {
  commission: number;
  start_date;
}

export class VdspCommission {
  commission: number;
  start_date;
}

export class Commission {
  contract_commission: number;
  effective_date;
}

export class AdServiceFee {
  commission: number;
  start_date;
}

export class tdspCommission {
  commission: number;
  start_date;
}

export class Transaction {
  amount: number;
  description: string;
  transaction_currency: string;
  constructor() {
    this.description = '';
    this.transaction_currency = '';
  }
}

export class SystemCommission {
  system_commission: number;
  effective_date;
}

export class DataCommission {
  data_commission: number;
  start_date;
}

export class PaymentDetails {
  amount: number;
  description: string;
  transaction_currency: string;
  constructor() {
    this.description = "";
  }
}

export class NonApnxCommission {
  latest_contract_commission: adspCommission
  active_contract_commission: adspCommission
  latest_system_commission: adspCommission
  active_system_commission: adspCommission
  latest_data_commission: adspCommission
  active_data_commission: adspCommission
  latest_cdc_commission: adspCommission
  active_cdc_commission: adspCommission
  latest_sdc_commission: adspCommission
  active_sdc_commission: adspCommission
  active_asf_commission: VdspCommission
  latest_asf_commission: VdspCommission
}

export class ApnxCommission {
  latest_contract_commission: Commission
  active_contract_commission: Commission
  latest_system_commission: SystemCommission
  active_system_commission: SystemCommission
  latest_data_commission: DataCommission
  active_data_commission: DataCommission
  latest_cdc_commission: VdspCommission
  active_cdc_commission: VdspCommission
  latest_sdc_commission: VdspCommission
  active_sdc_commission: VdspCommission
  active_asf_commission: VdspCommission
  latest_asf_commission: VdspCommission
}

export const agencyRoleOptions = [
  { value: 'agency_primary_admin', name: 'Agency Primary Admin' },
  { value: 'agency_admin', name: 'Agency Admin' },
  { value: 'managed_agency_user', name: 'Manage Serve Agency User'},
  { value: 'agency_user', name: 'Agency User' },
  { value: 'self_read_only_agc_user', name: 'Agency User - Read Only' },
  { value: 'agency_reporting_user', name: 'Agency Reporting User' },
  { value: 'agency_advertiser_reporting_user', name: 'Agency Advertiser Reporting User' },
  { value: 'agency_api_user', name: 'Agency API User'},
  { value: 'outlet_app_user', name: 'Outlet App User'}
]

export const advertiserRoleOptions = [
  { value: 'advertiser_primary_admin', name: 'Advertiser Primary Admin' },
  { value: 'advertiser_admin', name: 'Advertiser Admin' },
  { value: 'managed_advertiser_user', name: 'Manage Serve Advertiser User'},
  { value: 'advertiser_user', name: 'Advertiser User' },
  { value: 'self_read_only_adv_user', name: 'Advertiser User - Read Only' },
  { value: 'advertiser_reporting_user', name: 'Advertiser Reporting User' },
  { value: 'advertiser_api_user', name: 'Advertiser API User'},
  { value: 'outlet_app_user', name: 'Store User'}
]

export interface PlatformNotification {
  subject: string;
  description: string;
  type: string;
  effective_date;
  advertiser_ids: Array<any>;
  agency_ids: Array<any>;
  agency_advertiser_ids: Array<any>;
  management_type: string;
  role_types: Array<any>;
  recipients_info: Array<any>;
}

export const notificationTypeOptions: Array<any> = [
  { value: "email", label: "Via Email" },
  { value: "product", label: "In Platform" },
];

export const redirectToAgnAdvCreate = {
  tdsp: "tdsp/agency-advertiser/create",
  bdsp: "bdsp/agency-advertiser/create",
  adsp_eu: "adsp/agency-advertiser/create",
  adsp_us: "adsp/agency-advertiser/create",
};
